/* eslint-disable no-unused-vars */
export const asyncTimeOut = (time) => new Promise((res, rej) => {
  setTimeout(() => {
    res();
  }, time);
});
